module.exports = __webpack_public_path__ + "img/alert_email_error_icon.b3de18d4.png";